// extracted by mini-css-extract-plugin
export var avatar = "_p5-3";
export var avatarContainer = "_p5-2";
export var avatarSpacer = "_p5-5";
export var avatarSpacerContainer = "_p5-4";
export var avatarStackContainer = "_p5-1";
export var bubble = "_p5-0";
export var remainderBubble = "_p5-6";